import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect, useState } from 'react'
import { reportService } from '../services/reportService'
import { ReportTransactionParams } from '../services/reportService/reportTransactions'
import { endOfMonth, startOfMonth } from 'date-fns'

export const useReportTransactions = () => {
  const [params, setParams] = useState<ReportTransactionParams | undefined>({
    limit: 100,
    startDate: startOfMonth(new Date()).toISOString(),
    endDate: endOfMonth(new Date()).toISOString(),
  })
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['reportTransactions', params],
    queryFn: async () => reportService.reportTransaction(params),
    placeholderData: keepPreviousData,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
  }
}
